export enum ConfigurationKeys {
  UPLOAD_ROOT_URL = 'UPLOAD_ROOT_URL',
  INSURANCE_FOLDER_FILES = 'INSURANCE_FOLDER_FILES',
}
export interface Configuration {
  key: string;
  value: string;
  observation: string;
}
